import { PasswordInput, TextInput } from "../../shared/FormInputs";
import { Loading } from "../../ui";

interface AuthUpdateViewProps {
  email: string;
  password: string;
  isLoading: boolean;
  errors: {
    password?: string;
    general?: string;
  };
  onPasswordChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const AuthUpdateView = ({
  email,
  password,
  isLoading,
  errors,
  onPasswordChange,
  onSubmit,
}: AuthUpdateViewProps) => {
  return (
    <div>
      <div className="mb-8">
        <h2 className="mb-2 text-3xl font-bold text-foreground">Update Password</h2>
        <p className="text-muted-foreground">Secure your account with a new password.</p>
      </div>

      <form onSubmit={onSubmit}>
        <div className="space-y-6">
          <TextInput
            type="email"
            label="Email Address"
            value={email}
            onChange={() => {}}
            disabled
            className="bg-surface-sunken opacity-70"
            autoComplete="email"
          />
          <PasswordInput
            label="New Password"
            value={password}
            placeholder="Enter your new password"
            onChange={onPasswordChange}
            required
            error={errors.password}
            autoComplete="new-password"
          />
        </div>

        {errors.general && (
          <div className="mt-6 rounded-r-lg border-l-4 border-destructive bg-destructive-subtle p-4 text-sm text-destructive-text">
            <div className="flex items-center">
              <svg className="mr-2 h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
              {errors.general}
            </div>
          </div>
        )}

        <div className="mt-8">
          <button
            className={`w-full rounded-xl bg-primary px-4 py-3.5 font-bold text-white shadow-sm transition-all duration-200 hover:bg-primary-hover focus-visible:shadow-focus ${
              isLoading ? "transform-none cursor-not-allowed opacity-70" : "hover:-translate-y-0.5"
            }`}
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="flex items-center justify-center">
                <span className="mr-3">
                  <Loading size={20} tone="inverse" fullScreen={false} />
                </span>
                Processing...
              </span>
            ) : (
              "Update Password"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};
